/**
 * @description modes of editor preview
 */
export enum PreviewDeviceMode {
  DESKTOP = 'DESKTOP',
  MOBILE = 'MOBILE',
}
